import { HistoryIcon } from './HistoryIcon';

/**
 * author: Google
 * id 55AF2D53-7FAD-4A1D-8440-10301C95D3B8
 * name history
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/history.svg
 * tags
 * - Date / Time 
 */
export const RestoreClockIcon = HistoryIcon;
export default RestoreClockIcon